import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { ApolloError } from "@apollo/client";
import { useAuth } from "src/hooks/useAuth";
import { Query } from "src/types/ctgraphql.d";
import { moneyFragment } from "src/hooks/useCart";
import { locale, storeConfig } from "src/config/app-config";
import { Iso2LetterLocale } from "src/lib/Intl";
interface ShippingMethodsByLocationData {
  shippingMethodsByLocation: Query["shippingMethodsByLocation"];
}

interface ShippingMethodsByLocationVars {
  locale: string;
  country: string;
}

interface ShippingMethodsByLocationHook {
  data?: ShippingMethodsByLocationData;
  loading: boolean;
  error?: ApolloError;
}

const SHIPPING_METHODS = gql`
  query shippingMethodsByLocation($locale: Locale!, $country: Country!) {
    shippingMethodsByLocation(country: $country) {
      id
      key
      name
      localizedName(locale: $locale)
      localizedDescription(locale: $locale)
      isDefault
      zoneRates {
        zone {
          id
          name
          key
        }
        shippingRates {
          isMatching
          price {
            ...money
          }
          freeAbove {
            ...money
          }
        }
      }
    }
  }

  ${moneyFragment}
`;

const useShippingMethodsByLocation = ({
  country,
  onCompleted,
}: {
  country: Iso2LetterLocale;
  onCompleted?: () => void;
}): ShippingMethodsByLocationHook => {
  const { session, accessToken } = useAuth();

  const { data, loading, error } = useQuery<
    ShippingMethodsByLocationData,
    ShippingMethodsByLocationVars
  >(SHIPPING_METHODS, {
    variables: {
      locale: locale || storeConfig.locale,
      country,
    },
    context: { useCT: true, token: accessToken || "" },
    skip: !session,
    onCompleted,
  });

  return { data, loading, error };
};

export { useShippingMethodsByLocation };
